export default __webpack_public_path__ + "static/incLogo-642e95f7f3bd3ec0d831c047e596263b.png";